import React, { Fragment, useState, useEffect, useContext, useRef } from 'react'
import ReactGA from 'react-ga'
import Cookies from 'js-cookie'
import { get, set } from 'idb-keyval'
// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
import dynamic from 'next/dynamic'
import useWindow from 'Hooks/useWindow'
//import LoyaltySignUpModalContent from './LoyaltySignUpModalContent'
import { NavigationContext } from 'Contexts/Navigation/NavigationContext'

import { UserContext } from 'Contexts/UserContext/UserContext'
import { NotificationContext } from '../../Contexts/NotificationContext/NotificationContext'

import Event from 'Utilities/Event'

// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
const LoyaltySignUpModalContent = dynamic(/* #__LOADABLE__ */() => import('./LoyaltySignUpModalContent'))

const hasDisplayedModalKey = 'LoyaltySignupModal_HasDisplayedPreviously'
const lastPageViewedKey = 'LoyaltySignupModal_LastPageViewed'
const numberOfPagesViewedKey = 'LoyaltySignupModal_NumberOfPagesViewed'

const LoyaltySignUpModal = (disabledPathNames) => {
    const { state: navigationState, dispatch: navigationDispatch } = useContext(NavigationContext)
    const [isOpen, setIsOpen] = useState(false)
    const modal = useRef(null)
    const [showModal, setShowModal] = useState(true)
    const { DismissAllNotifications } = useContext(NotificationContext)

    useEffect(() => {
        const { loyalty } = navigationState;
        setIsOpen(loyalty?.isLoyaltySignupModalOpen ?? false)
        if (loyalty?.isLoyaltySignupModalOpen) {
            DismissAllNotifications()
            set(hasDisplayedModalKey, true)
            Event({
                category: 'Loyalty Engagement',
                action: 'Modal',
                label: 'Displayed Loyalty Modal'
            }, true)
        }
    }, [navigationState])

    const handleNavigationChange = (value) => navigationDispatch({
        type: 'setLoyaltyState',
        payload: {
            loyaltyState: {
                isLoyaltySignupModalOpen: value
            }
        }
    })

    useWindow((window) => {
        if (window.location.href.includes('/buy')) setShowModal(false)
        else if (window.location.href.includes('/account/loyalty')) setShowModal(false)
        else if (
            disabledPathNames &&
            disabledPathNames.length &&
            disabledPathNames.some(
                (pathname) => pathname && window && window.location.pathname && pathname.toLowerCase() === window.location.pathname.toLowerCase()
            )
        )
            setShowModal(false)
    })
    const { context: customerState } = useContext(UserContext)
    useEffect(() => {
        const isHydrated = customerState?.hydrated
        const isLoyaltyBetaUser = customerState?.isLoyaltyBetaUser
        const isLoyaltyRegisteredUser = customerState?.isLoyaltyRegisteredUser
        get(hasDisplayedModalKey).then((hasDisplayedModal) => {
            if (showModal && !hasDisplayedModal && isHydrated && isLoyaltyBetaUser && !isLoyaltyRegisteredUser) {
                const currentPage = document.location.pathname
                const isCurrentPageShoppingCart = new RegExp('^/shoppingcart/?$', 'i').test(currentPage)
                const isCurrentPageLayoutPage = new RegExp('^/ds9layout/?$', 'i').test(currentPage)
                //do not show loyalty documetation page && different ones?
                //Which pages to show on?
                get(lastPageViewedKey).then((lastPageViewed) => {
                    get(numberOfPagesViewedKey).then((numberOfPagesViewedValue) => {
                        let numberOfPagesViewed = parseInt(numberOfPagesViewedValue) || 0
                        if (lastPageViewed != currentPage) {
                            set(lastPageViewedKey, window.location.href)
                            set(numberOfPagesViewedKey, numberOfPagesViewed ? ++numberOfPagesViewed : 1)
                        }

                        let modalTimeout = 25005
                        if (isCurrentPageShoppingCart) {
                            modalTimeout = 0
                        } else if (isCurrentPageLayoutPage) {
                            modalTimeout = 30000
                        } else if (numberOfPagesViewed >= 2) {
                            modalTimeout = 2001
                        }

                        setTimeout(function () {
                            handleNavigationChange(true)
                        }, modalTimeout)
                    })
                })
            }
        })
    }, [typeof document, customerState])

    return (
        <Fragment>
            {isOpen ?
                <LoyaltySignUpModalContent ref={modal} />
                : false}
        </Fragment>
    )
}
export default LoyaltySignUpModal
